
export const useAccess = () => {
  const ass = JSON.parse(sessionStorage.getItem("access") || "{}")
  const { menus, permissions, ...rest } = ass
  return { ...rest }
}